import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthStatusService {
  private isRefreshingTokenSubject = new BehaviorSubject<boolean>(true);

  // Observable to check if the token is being refreshed
  get isRefreshingToken$() {
    return this.isRefreshingTokenSubject.asObservable();
  }

  // Setter for the flag
  setRefreshingTokenStatus(isRefreshing: boolean) {
    this.isRefreshingTokenSubject.next(isRefreshing);
  }
}
